import { Form, Input, Select } from "antd";
import { PREFIX_CLS } from "constants/common";
import THEME from "constants/themes";
import styled, { css } from "styled-components";
import { StyledWrapper } from "styled-components/Common/CommonStyled";

export const StyledDynamicWidgetWrapper = styled.div<{
	bgUrl?: string;
	bgColor?: string;
	isMobile?: boolean;
}>`
	display: flex;
	padding: 36px 0;
	position: relative;
	overflow-y: auto;

	* {
		font-family: "IBM Plex Sans", sans-serif;
	}

	&::before {
		${(props) =>
			props.bgUrl
				? css`
						background-image: url(${props.bgUrl});
						background-size: cover;
						background-repeat: no-repeat;
				  `
				: css`
						background: ${props.bgColor};
				  `}

		content: "";
		height: 100%;
		width: 100%;
		left: 0;
		position: fixed;
		top: 0;
		will-change: transform;
		z-index: -1;
	}

	${({ isMobile }) =>
		isMobile &&
		css`
			padding: 0;
		`}
`;

export const StyledDynamicWidgetFormWrapper = styled.div<{
	background?: string;
	isMobile?: boolean;
	minHeight?: string;
}>`
	background-color: ${({ background }) => background || THEME.colors.white};
	display: block;
	align-items: center;
	height: auto;
	width: 700px;
	gap: 24px;
	overflow: auto;
	margin: 0 auto;
	border-radius: 12px;
	padding: 24px;
	${({ minHeight }) => minHeight && `min-height: ${minHeight}`};

	${({ isMobile }) =>
		isMobile &&
		css`
			border-radius: unset;
		`}
`;

export const StyledWidgetSectionWrapper = styled(StyledWrapper)<{ background?: string }>`
	background-color: ${({ background }) => `${background || THEME.colors.white} !important`};
	border: 1px solid ${THEME.colors.gray5};
	padding: 24px;
	border-radius: 12px;
	width: 100%;
	max-width: 700px;
	margin: 24px auto;
`;

export const StyledSectionTitleWrapper = styled(StyledWrapper)`
	display: flex;
	flex-direction: column;
	gap: 8px;
	text-align: center;
	margin: 0 0 24px 0;
	align-items: center;
	justify-content: center;
`;

export const StyledSectionTitle = styled.div<{ margin?: string }>`
	${({ margin }) => margin && `margin: ${margin}`};
	font-size: 20px;
`;

export const StyledHelperText = styled.div`
	padding: 0;
	color: ${THEME.colors.gray1};
	font-size: 12px;
`;

export const StyledUploadWrapper = styled.div<{ background?: string }>`
	text-align: center;
	border-radius: 8px;
	height: 120px;
	border: 1px dashed ${THEME.colors.gray3};
	${({ background }) => background && `background: ${background}`};
`;

export const StyledSocialButtonWrapper = styled(StyledWrapper)`
	svg {
		width: 32px !important;
		height: 32px !important;
	}
`;

export const StyledFormItem = styled(Form.Item)<{ margin?: string }>`
	${({ margin }) => margin && `margin: ${margin}`};

	label {
		.hidden-label {
			visibility: hidden;
		}

		color: ${THEME.colors.darkBlue1};
		font-size: 12px !important;
	}

	.${PREFIX_CLS}-form-item-explain {
		margin: 4px 0 0 0;
		font-size: 10px;
		text-align: left !important;
		transition: none;
		animation: none;
		height: 15px;
	}

	.${PREFIX_CLS}-input {
		height: 34px;
		border-radius: 4px !important;

		&:hover,
		&:focus {
			border-color: ${THEME.colors.darkBlue2};
			box-shadow: none;
		}
	}

	.${PREFIX_CLS}-select-selector:hover, .${PREFIX_CLS}-select-selector:focus-within {
		border-color: ${THEME.colors.darkBlue2} !important;
		box-shadow: none !important;
	}
`;

export const StyledTextArea = styled(Input.TextArea)``;

export const StyledSelect = styled(Select)`
	.${PREFIX_CLS}-select-selector {
		border-radius: 4px !important;
		min-height: 34px !important;
	}
`;

export const StyledWidgetLogoWrapper = styled(StyledWrapper)`
	width: fit-content;
	margin: 16px auto 0 auto !important;
	padding: 6px 12px;

	&.dark-wrapper {
		border-radius: 0px 6px 6px 6px;
		background-color: ${THEME.colors.darkBlue1};
	}
`;
